module.exports = __webpack_public_path__ + "static/media/toupper.e530b794.ico";